import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { AccaBoostConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';

import { AccaBoostToken } from '../../../../reward-tokens/reward-tokens.model';

@Component({
    selector: 'bs-acca-boost-max-reward',
    templateUrl: './acca-boost-max-reward.component.html',
    styleUrls: ['./acca-boost-max-reward.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AccaBoostMaxRewardComponent implements OnChanges {
    @Input() token: AccaBoostToken;
    maxReturns: string;

    @HostBinding('class') className = 'acca-boost-module acca-boost-max-reward';

    readonly isEnhancedLayoutEnabled = this.accaBoostConfig.isEnhancedLayoutEnabled;

    constructor(
        public sitecore: Sitecore,
        private accaBoostConfig: AccaBoostConfig,
    ) {}

    ngOnChanges() {
        this.maxReturns = this.token.maxReward.toString();
    }
}
